import { usePayment } from '$api-clients/hooks';
import { useViewReportAs } from '../helpers';

export function useReportsConfiguration() {
  const viewReportAs = useViewReportAs();

  return usePayment('/reporting/config', {
    params: {
      query: {
        viewReportAs,
      },
    },
  });
}

/**
 * Reports config for the logged-in user, ignoring any active view-as.
 * Use this when the decision must reflect the viewer (e.g. whether the
 * View As control itself is available), not the user currently being
 * viewed as.
 */
export function useViewerReportsConfiguration() {
  return usePayment('/reporting/config', {
    params: { query: {} },
  });
}

export function useAllTimeStartDate() {
  const { data: config } = useReportsConfiguration();
  return config?.closingDateStart;
}
